<div style="width:100%;max-height:80vh;background:#ffffff;border-radius:16px;display:flex;flex-direction:column;overflow:hidden;">
  <div style="display:flex;align-items:flex-start;justify-content:space-between;padding:24px 28px;border-bottom:1px solid #eef1f4;">
    <div>
      <h1 style="margin:0 0 4px;font-size:17px;font-weight:800;">{{ 'proposals.dialogs.addShipping.title' | transloco }}</h1>
      <p style="margin:0;font-size:13px;color:#8892a0;">
        {{ 'proposals.dialogs.addShipping.subtitlePrefix' | transloco }} <strong>{{ product?.originPort?.name }}</strong>{{ 'proposals.dialogs.addShipping.subtitleSuffix' | transloco }}
      </p>
    </div>
    <button type="button" (click)="close()" [attr.aria-label]="'common.close' | transloco" style="border:none;background:transparent;cursor:pointer;padding:8px;border-radius:8px;min-height:44px;min-width:44px;">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
    </button>
  </div>

  <div *ngIf="errorMessage" style="margin:16px 28px 0;padding:10px 14px;background:#fdf1d6;color:#92610a;font-size:12.5px;font-weight:600;border-radius:9px;">
    {{ errorMessage }}
  </div>

  <div style="padding:16px 28px 0;overflow:auto;flex:1;">
    <h3 *ngIf="container" data-testid="shipping-container-title" style="margin:0 0 8px;font-size:13.5px;font-weight:700;">
      {{ 'proposals.dialogs.addShipping.containerBlockTitle' | transloco: { count: container.count, type: container.quantityType?.name, capacity: container.capacityM3 } }}
    </h3>
    <app-freight-destination-filter [options]="destinationOptions" [value]="destinyPortId" [moreFreights]="moreFreights"
      (valueChange)="changeDestination($event)" (searchChange)="changeSearch($event)"></app-freight-destination-filter>
    <app-freight-options-table [options]="options" [containerViews]="container ? views : null"
      [pickLabelKey]="container ? 'proposals.dialogs.addShipping.changeFreight' : null"
      [selectedId]="selectedId" (select)="onSelect($event)"></app-freight-options-table>
  </div>

  <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 28px;border-top:1px solid #eef1f4;">
    <span style="font-size:12.5px;color:#8892a0;">{{ 'proposals.dialogs.addShipping.availableCount' | transloco: { count: options.length } }}</span>
    <button type="button" (click)="close()" style="border-radius:9px;font-size:13.5px;font-weight:600;padding:10px 18px;min-height:44px;border:1px solid #d7dce2;background:#ffffff;color:#0f172a;cursor:pointer;">{{ 'common.close' | transloco }}</button>
  </div>
</div>
